// Fichero que contendrá todos los estilos por defecto de la aplicación. 

/*Las constantes que pertenecen a este bloque, solo pueden ser usadas como tal
****ej: (estilosTextosPrincipales.encabezadoH1.fontSize)**********************/

export const colores = {
    principales: {
        hover: '#0B4C1A',                         
        principal: '#087021',
        apoyo: '#C4DDCA',
        apoyo1: '#EDF5EF',
        //apoyo2: '#C8E6CF',
        fondoEspecifico: '#F7FBF8',
        blanco: '#FFFFFF',
        required: '#E2573C'
    },
    escalaGrises: {        
        cien: '#333333',//Color principal en el prototipo
        noventa: '#444444',
        ochenta: '#555555',
        setenta: '#7B7B7B',
        sesenta: '#909090',
        cincuenta: '#999999',
        cuarenta: '#B3B3B3',
        treinta: '#C8C8C8',
        veinte: '#D8D8D8',
        diez: '#EEEEEE',//Color contenedor en el prototipo
        cinco: '#F5F5F5',//Color apoyo especifico en el prototipo
        cero: '#FFFFFF',
        principal: '#333333',
        contenedor: '#F5F5F5',
        secundario: '#767676',
        apoyoEspecífico: '#EEEEEE',
        apoyo: '#BEBEBE'
    },
    estado: {
        exito: '#2ABC67',
        informacion: '#5BC0DE',
        atencion: '#F0AD4E',
        error: '#D9534F',
    },
    accesibilidad: {
        focus: '#9831AD',
    },
}

/////////////////////////////////////////////////////////////


export const tipografia = {
    regular: 'Source Sans Pro',
    bold: 'Source Sans Pro Bold',
    light: 'Source Sans Pro Light',
    medium: 'Source Sans Pro Medium',
    thin: 'Source Sans Pro Thin'
}

export const tipografiaMontserrat = {
    bold: 'Montserrat' 
}

export const tipograficaNotoSans = {
    regular: 'Noto Sans  HK Regular',
    bold: 'Noto Sans  HK Bold',
    light: 'Noto Sans  HK Light',
    medium: 'Noto Sans  HK Medium',
    thin: 'Noto Sans  HK Thin'
}


/***Las constantes que pertenecen a este bloque, además de poder ser usadas como tal
****ej: (estilosTextosPrincipales.encabezadoH1.fontSize) también puedes ser implementadas
****directamente en bloque en una clase CSS ej: (...estilosTextosPrincipales.encabezadoH1)
****en el último ejemplo se aplicaría las propiedades fontFamily, fontSize y lineHeight.
****Para poder usarlo de esta manera, las claves del último nivel deben ser iguales a la 
****propiedad CSS correspondiente********************************************************/

export const estilosTextosPrincipales = {
    encabezadoH1: {
        fontFamily: tipografiaMontserrat.bold,
        fontSize: '28px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '32px',
    },
    encabezadoH2: {
        fontFamily: tipografia.regular,
        fontSize: '26px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '32px',

    },
    encabezadoH3: {
        fontFamily: tipografia.regular,
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '32px',
    },
    encabezadoH4: {
        fontFamily: tipografia.regular,
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '26px',
    },
    encabezadoH5: {
        fontFamily: tipografia.regular,
        fontSize: '17px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '24px',
    },
    body1: {
        fontFamily: tipografia.regular,
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '24px',
    },
    body2: {
        fontFamily: tipografia.regular,
        fontSize: '13px',
        lineHeight: '16px',
    },
}

/////////////////////////////////////////////////////////////

export const backgroundRectangle = {
    width: '90%',
    height: 'fit-content',
    margin: 'auto',
    marginTop: '2%',
    marginBottom: '5%',
    backgroundColor: colores.escalaGrises.cero,
    boxShadow: '0 0 6px 0 rgba(188,197,201,0.5), 0 0 30px 0 rgba(188,197,201,0.28)'
}

/////////////////////////////////////////////////////////////
export const pantallaCarga = {
    zIndex: 1,
    color: '#fff',
}

/////////////////////////////////////////////////////////////Estilo para aplicar a los enlaces
export const links = {
    color: colores.principales.principal,
    textDecoration: 'none',
    fontFamily: tipografia.medium,
    fontStyle: 'normal',
    fontWeight: 'normal',
    outline: '0',
    fontSize: '14px',
    lineHeight: '18px',
    '&:hover': {
        textDecoration: 'underline',
     },
     '&:focus': {
        textDecoration: 'underline',
     },
    
}

/////////////////////////////////////////////////////////////Estilo para aplicar a los botones primarios (a la espera del desarrllo del componente boton y migrar el estilo a este)
export const buttonPrimaryBig = {
    fontFamily: tipografia.medium,
    fontSize: '13px',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing:  '0.5px',
    textAlign: 'center',
    height: '40px',
    minWidth: '135px',
    left: '330px',
    top: '286px',
    borderRadius: '4px !important',
    padding: '8px 24px 8px 24px',
    background: colores.principales.principal,
    color: colores.escalaGrises.cero,
    border: `solid 1px ${colores.principales.principal}`,
    cursor: 'pointer',
    '&:hover': {
       background: colores.principales.hover,
    },
    '&:disabled': {
        backgroundColor: colores.principales.apoyo,
        color: colores.escalaGrises.cero
    },
    '&:focus': {
        background: colores.principales.hover,
    }
}
export const buttonPrimarySmall = {
    fontFamily: tipografia.medium,
    fontSize: '13px',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing:  '0.5px',
    textAlign: 'center',
    height: '40px',
    minWidth: '103px',
    left: '330px',
    top: '286px',
    borderRadius: '4px',
    padding: '8px 24px 8px 24px',
    background: colores.principales.principal,
    color: colores.escalaGrises.cero,
    border: `solid 1px ${colores.principales.principal}`,
    cursor: 'pointer',
    '&:hover': {
        background: colores.principales.hover,
    },
    '&:disabled': {
        backgroundColor: colores.principales.apoyo,
        color: colores.escalaGrises.cero
    },
    '&:focus': {
        background: colores.principales.hover,
    }
}
export const buttonSecundaryBig = {
    fontFamily: tipografia.medium,
    fontSize: '13px',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing:  '0.5px',
    textAlign: 'center',
    height: '40px',
    minWidth: '135px',
    left: '330px',
    top: '286px',
    borderRadius: '4px',
    padding: '8px 24px 8px 24px',
    background: 'transparent',
    color: colores.principales.principal,
    border: `1px solid ${colores.principales.principal}`,
    cursor: 'pointer',
   '&:hover': {
        border: `1px solid ${colores.principales.hover}`,        
        color: colores.principales.hover 
    },
    '&:disabled': {
        border: `1px solid ${colores.principales.apoyo}`,        
        color: colores.principales.apoyo,
        cursor: 'default'
    },
    '&:focus': {
        border: `1px solid ${colores.principales.hover}`,        
        color: colores.principales.hover 
    }
}
export const buttonSecundarySmall = {
    fontFamily: tipografia.medium,
    fontSize: '13px',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing:  '0.5px',
    textAlign: 'center',
    height: '40px',
    minWidth: '103px',
    left: '330px',
    top: '286px',
    borderRadius: '4px',
    padding: '8px 24px 8px 24px',
    background: 'transparent',
    color: colores.principales.principal,
    border: `1px solid ${colores.principales.principal}`,
    cursor: 'pointer',
   '&:hover': {
        border: `1px solid ${colores.principales.hover}`,
        color: colores.principales.hover 
    },
    '&:disabled': {
        border: `1px solid ${colores.principales.apoyo}`,        
        color: colores.principales.apoyo
    },
    '&:focus': {
        border: `1px solid ${colores.principales.hover}`,
        color: colores.principales.hover 
    }
}